exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".NormalField {\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    font-size: 16px;\n    width: 256px;\n    height: 72px;\n    position: relative;\n    background-color: transparent;\n    font-family: Roboto, sans-serif;\n}\n\n.NormalField-label {\n    font-size: 14px;\n    line-height: 22px;\n    /* transform: scale(0.75); */\n    /* transform-origin: left top 0px; */\n    color: rgba(0, 0, 0, 0.3);\n    padding-top: 16px;\n}\n\n.NormalField-label {\n    padding: 8px 0;\n}\n\n.Question,\n.NPUCECard {\n    padding-left: 16px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/styles/NormalField.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/styles/NormalField.css
// module chunks = 0